import Modal from "components/elements/Modal";
import classes from "./classes.module.scss";
import Typography, { ITypo } from "components/elements/Typography";
import Button, { EButtonVariant } from "components/elements/Button";
import I18n from "components/materials/I18n";
import { useCallback } from "react";
import SubscriptionService from "services/SubscriptionService";
import { container } from "tsyringe";
import { useNavigate } from "react-router-dom";
import ModuleConfig from "configs/ModuleConfig";

const modules = container.resolve(ModuleConfig).get().modules;
const subscriptionService = container.resolve(SubscriptionService);

type IProps = {
	subscriptionId: string;
	isOpen: boolean;
	onClose: () => void;
	/** Dossier né d'une opération reprise : il ne porte qu'elle. */
	isLegacy?: boolean;
};

export default function ArchiveSubscriptionModal(props: IProps) {
	const navigate = useNavigate();

	const archive = useCallback(() => {
		subscriptionService
			.archive(props.subscriptionId)
			.then(() => {
				props.onClose();
				navigate(modules.pages.MOSubscriptions.props.pages.Draft.props.path);
			})
			.catch((err) => {
				console.error(err);
			});
	}, [props, navigate]);

	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose} className={classes["root"]}>
			<Typography typo={ITypo.H1}>{I18n.asset.pages.mo_subscription_summary.archive_subscription_modal.title}</Typography>
			<Typography typo={ITypo.P_MEDIUM_BOLD}>
				{props.isLegacy
					? I18n.asset.pages.mo_subscription_summary.archive_subscription_modal.legacy_description
					: I18n.asset.pages.mo_subscription_summary.archive_subscription_modal.description}
			</Typography>
			<div className={classes["button-container"]}>
				<Button onClick={props.onClose} variant={EButtonVariant.OUTLINED}>
					{I18n.asset.pages.mo_subscription_summary.archive_subscription_modal.cancel_button}
				</Button>
				<Button onClick={archive}>{I18n.asset.pages.mo_subscription_summary.archive_subscription_modal.confirm_button}</Button>
			</div>
		</Modal>
	);
}
